import React from 'react';

import { Feature, Heading, PageTitle } from '../../../components';
import { features } from '../../../constants';



const FeaturePage = () => {  
  return (   
    <> 

      {/* Page Title */}
      <PageTitle title={'Features'} page={'Features'} />
      
      {/* Features Section */}
      <section className='features'>

        {/* Section Heading */}
        <Heading title={'Our Features'} subTitle={'What Makes Us Unique'} />

        {/* Container for feature items */}
        <div className="box-container">

          {/* Map through each features and render each feature */}
          {features.map((feature) => (
            <Feature key={feature.id} feature={feature} />
          ))}

        </div>

      </section>
      
    </>
  )
}

export default FeaturePage;